import React from "react";
import { Navigate } from "react-router-dom";

function readJsonList(key) {
  try {
    const value = JSON.parse(localStorage.getItem(key) || "[]");
    return Array.isArray(value) ? value : [];
  } catch (err) {
    return [];
  }
}

export default function SuperuserRoute({ children, allowedRoles = [], allowedPermissions = [] }) {
  const isSuperuser = localStorage.getItem("is_superuser") === "true";
  const role = localStorage.getItem("portal_role") || "client";
  const roles = new Set([role, ...readJsonList("portal_roles")]);
  const permissions = new Set(readJsonList("permissions"));

  if (isSuperuser) return children;

  const roleAllowed = allowedRoles.length ? allowedRoles.some((item) => roles.has(item)) : false;
  const permissionAllowed = allowedPermissions.length ? allowedPermissions.some((item) => permissions.has(item)) : false;
  const legacyStaffAllowed = !allowedRoles.length && !allowedPermissions.length && localStorage.getItem("is_staff") === "true";

  if (!roleAllowed && !permissionAllowed && !legacyStaffAllowed) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
